import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
function useHasMounted() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasMounted = _useState2[0],
    setHasMounted = _useState2[1];
  useEffect(function () {
    setHasMounted(true);
  }, []);
  return hasMounted;
}
export default useHasMounted;